import { AppRoutes } from 'containers/App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const usersRoot = 'users';
export const usersOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${usersRoot}`;
